import { render } from "./SinisterDetails.vue?vue&type=template&id=1e66d156&scoped=true"
import script from "./SinisterDetails.vue?vue&type=script&lang=js"
export * from "./SinisterDetails.vue?vue&type=script&lang=js"

import "./SinisterDetails.vue?vue&type=style&index=0&id=1e66d156&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e66d156"]])

export default __exports__